export const STATUS_CODE = {
    1: "未注册",
    2: "注册成功",
    3: "车辆已经被注册",
    4: "数据库中无该车辆",
    5: "终端已经注册",
    6: "数据库中无该终端",
    7: "鉴权成功",
    8: "鉴权失败",
    9: "注销成功",
    10: "注销失败",
    11: "注册失败"
};